import "./css/App.css";
import "./css/App-Mobile.css";
import "./css/TextStyle.css";
import "./css/Buttons.css";
import { useEffect, useRef } from "react";
import {
  BackgroundSlider,
  Header,
  TimeCounter,
  Footer,
  Left,
  Locations,
} from "./ui/pages";
import { ModelPrayerTime } from "./model/ModelPrayerTime";
import { getPrayerTime, getZone, API_KEY } from "./api/api";
import { Storage } from "./data/Storage";
import { setKey, setLanguage, setRegion, fromLatLng } from "react-geocode";
import { useLocation } from "react-router-dom";
import { monthsIslamic, staticLocation } from "./utils/utils";

const App = () => {
  const childRef = useRef();
  const prayerRef = useRef();
  const prayerLeftRef = useRef();
  const counterRef = useRef();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleSuccessLocation = (position) => {
    const { latitude, longitude } = position.coords;
    //const latitude = 3.246905;
    //const longitude = 101.702859;
    getAddress(latitude, longitude);
  };

  const handleErrorLocation = (err) => {
    //setError(err.message);
  };

  const locationPermission = () => {
    if (!navigator.geolocation) {
      //setError("Geolocation is not supported by your browser.");
      return;
    }

    // Request permission and get current position
    navigator.geolocation.getCurrentPosition(
      handleSuccessLocation,
      handleErrorLocation,
    );
  };

  const database = new Storage();
  var model = new ModelPrayerTime();
  if (database.getCode() == null) {
    database.setCode("JOH01");
  }
  model.code = database.getCode();

  if (database.getTown() == null) {
    database.setTown("Pulau Aur dan Pulau Pemanggil.");
  }
  model.location = database.getTown();

  function onClickLocation() {
    childRef.current?.showDialog();
  }

  function onHideDialog() {
    counterRef.current?.onHideDialog();
  }

  function onChangeLocation(item) {
    database.setCode(item.code);
    database.setTown(item.town);
    model.location = item.town;
    model.code = item.code;
    setTimeout(() => {
      requestGetPrayerTime();
    }, 200);
  }

  function onNewDay() {
    requestGetPrayerTime();
  }

  function getAddress(lat, long) {
    const country = "country";
    const state = "administrative_area_level_1";
    const town = "locality";
    const town2 = "political";
    const level2 = "administrative_area_level_2";
    var countryName = null;
    var stateName = null;
    var townName = null;
    var town2Name = null;
    fromLatLng(lat, long)
      .then((response) => {
        const addresses = response.results[0].address_components;
        addresses.forEach((item, i) => {
          const types = item.types;
          const type = types[0];
          if (type === country) {
            countryName = item.long_name;
          }
          if (type === state) {
            stateName = item.long_name;
          }
          if (type === town) {
            townName = item.long_name;
            counterRef.current?.setLocal(townName);
          }
          if (type === town2) {
            town2Name = item.long_name;
          }
          if (type === level2 && town2Name == null) {
            town2Name = item.long_name;
          }
          if (town2Name == null) {
            town2Name = townName;
          }
          counterRef.current?.setLocal(town2Name);
        });
        getZone(countryName, stateName, townName, town2Name).then((result) => {
          const zone = result.zone;
          const location = result.locations;
          if (zone) {
            database.setCode(zone);
            model.code = zone;
            database.setTown(location);
            model.location = location;
            requestGetPrayerTime();
          }
        });
      })
      .catch((error) => {
        console.error(error);
        //setAddress("Error fetching address.");
      });
  }

  useEffect(() => {
    setKey(API_KEY);
    setLanguage("ms");
    setRegion("MY");
    if (currentPath === "/") {
      locationPermission();
    } else {
      const loc = currentPath.replace("/", "");
      const { zone } = staticLocation(loc);
      model.code = zone;
    }
    requestGetPrayerTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function requestGetPrayerTime() {
    getPrayerTime(model.code).then((result) => {
      const hijriDate = result.hijri_date;
      const hijriMonth = result.hijri_month;
      const hijriYear = result.hijri_year;
      model.date = createDate(hijriDate, hijriMonth, hijriYear);
      const times = result.times;
      if (times) {
        model.imsak = createTime(times.imsak);
        model.subuh = createTime(times.subuh);
        model.syuruk = createTime(times.syuruq);
        model.zohor = createTime(times.zohor);
        model.asar = createTime(times.asar);
        model.maghrib = createTime(times.maghrib);
        model.isyak = createTime(times.isak);
        prayerRef.current?.prayerData(model);
        prayerLeftRef.current?.prayerData(model);
        counterRef.current?.prayerData(model);
      }
    });
  }

  function createDate(day, month, year) {
    return day + " " + monthsIslamic[month - 1] + " " + year;
  }

  function createTime(time) {
    const idxSeparator = time.indexOf(":");
    const hour = time.substring(0, idxSeparator);
    const minutes = time.substring(idxSeparator, time.length);

    const number = parseInt(hour);
    const finalHour = number < 10 ? "0" + number : "" + number;
    return finalHour + "" + minutes;
  }

  return (
    <div className="app-parent">
      <BackgroundSlider />
      <div className="table">
        <div className="app-header row">
          <Header />
        </div>

        <div className="app-content row">
          <div className="app-parent-content">
            <Left ref={prayerLeftRef} />
            <TimeCounter
              ref={counterRef}
              locationListener={onClickLocation}
              onNewDay={onNewDay}
            />
          </div>
        </div>

        <div className="app-footer row">
          <Footer ref={prayerRef} />
        </div>
      </div>
      <Locations
        ref={childRef}
        onHide={onHideDialog}
        onLocationChanged={(v) => onChangeLocation(v)}
      />
    </div>
  );
};

export default App;
